import React, { useState, useEffect, useRef } from 'react';
import banner1 from '../Image/banner1.jpg';
import banner2 from '../Image/banner2.png';
import banner3 from '../Image/banner3.png';
import banner4 from '../Image/banner4.png';
import banner5 from '../Image/banner5.png';

function HomeSlider() {
    const slides = [
        { img: banner1, alt: "Smart Security" },
        { img: banner2, alt: "Access Control System" },
        { img: banner3, alt: "EPABX / Intercom System" },
        { img: banner4, alt: "Networking Solutions" },
        { img: banner5, alt: "Annual Maintenance Contract" }
    ];

    const extendedSlides = [slides[slides.length - 1], ...slides, slides[0]];

    const [activeIndex, setActiveIndex] = useState(1);
    const [progress, setProgress] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(true);

    useEffect(() => {
        const duration = 6000;
        const step = 30;

        const interval = setInterval(() => {
            setProgress((prev) => {
                const next = prev + (step / duration) * 100;
                if (next >= 100) {
                    setIsTransitioning(true);
                    setActiveIndex((a) => a + 1);
                    return 0;
                }
                return next;
            });
        }, step);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        let timeout;
        if (activeIndex === extendedSlides.length - 1) {
            timeout = setTimeout(() => {
                setIsTransitioning(false);
                setActiveIndex(1);
            }, 800);
        } else if (activeIndex === 0) {
            timeout = setTimeout(() => {
                setIsTransitioning(false);
                setActiveIndex(extendedSlides.length - 2);
            }, 800);
        }
        return () => clearTimeout(timeout);
    }, [activeIndex, extendedSlides.length]);

    const prevSlide = () => {
        if (activeIndex <= 0) return;
        setIsTransitioning(true);
        setActiveIndex((prev) => prev - 1);
        setProgress(0);
    };

    const nextSlide = () => {
        if (activeIndex >= extendedSlides.length - 1) return;
        setIsTransitioning(true);
        setActiveIndex((prev) => prev + 1);
        setProgress(0);
    };

    const goToSlide = (idx) => {
        setIsTransitioning(true);
        setActiveIndex(idx + 1);
        setProgress(0);
    };

    return (
        <>
            <style dangerouslySetInnerHTML={{
                __html: `
                .home-hero-slider-container {
                    position: relative;
                    width: 100%;
                    overflow: hidden;
                    background-color: #ffffff;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.15);
                    height: 520px; /* Fixed height on desktop */
                }
                
                .home-hero-slider-img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                @media (max-width: 1400px) {
                    .home-hero-slider-container {
                        height: 450px;
                    }
                }

                @media (max-width: 1200px) {
                    .home-hero-slider-container {
                        height: 380px;
                    }
                }

                @media (max-width: 992px) {
                    .home-hero-slider-container {
                        height: 320px;
                    }
                }

                @media (max-width: 768px) {
                    .home-hero-slider-container {
                        height: 260px;
                    }
                }

                @media (max-width: 576px) {
                    .home-hero-slider-container {
                        height: 180px;
                    }
                }
            `}} />

            <div className="">
                {/* Progress Bar */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        height: '4px',
                        width: `${progress}%`,
                        background: 'linear-gradient(90deg, #3f51b5, #00d2ff)',
                        zIndex: 20,
                        transition: 'width 30ms linear'
                    }}
                />

                {/* Slides Wrapper */}
                <div
                    style={{
                        display: 'flex',
                        height: '100%',
                        transition: isTransitioning ? 'transform 0.8s cubic-bezier(0.77, 0, 0.175, 1)' : 'none',
                        transform: `translateX(-${activeIndex * (100 / extendedSlides.length)}%)`,
                        width: `${extendedSlides.length * 100}%`
                    }}
                >
                    {extendedSlides.map((slide, idx) => (
                        <div
                            key={idx}
                            style={{
                                width: `${100 / extendedSlides.length}%`,
                                height: '100%',
                                flexShrink: 0,
                                position: 'relative'
                            }}
                        >
                            <img
                                src={slide.img}
                                alt={slide.alt}
                                className="home-hero-slider-img"
                                style={{
                                    transform: activeIndex === idx ? 'scale(1)' : 'scale(1.02)',
                                    transition: 'transform 6s ease-out'
                                }}
                            />
                        </div>
                    ))}
                </div>

                {/* Navigation Arrows */}
                <button
                    onClick={prevSlide}
                    aria-label="Previous slide"
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '24px',
                        transform: 'translateY(-50%)',
                        background: 'rgba(15, 16, 22, 0.35)',
                        backdropFilter: 'blur(8px)',
                        WebkitBackdropFilter: 'blur(8px)',
                        color: '#fff',
                        border: '1px solid rgba(15, 16, 22, 0.1)',
                        borderRadius: '50%',
                        width: '50px',
                        height: '50px',
                        cursor: 'pointer',
                        zIndex: 15,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                        outline: 'none'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'rgba(15, 16, 22, 0.55)';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1.08)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'rgba(15, 16, 22, 0.35)';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                    }}
                >
                    <i className="fas fa-chevron-left" style={{ fontSize: '18px' }} />
                </button>

                <button
                    onClick={nextSlide}
                    aria-label="Next slide"
                    style={{
                        position: 'absolute',
                        top: '50%',
                        right: '24px',
                        transform: 'translateY(-50%)',
                        background: 'rgba(15, 16, 22, 0.35)',
                        backdropFilter: 'blur(8px)',
                        WebkitBackdropFilter: 'blur(8px)',
                        color: '#fff',
                        border: '1px solid rgba(15, 16, 22, 0.1)',
                        borderRadius: '50%',
                        width: '50px',
                        height: '50px',
                        cursor: 'pointer',
                        zIndex: 15,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                        outline: 'none'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'rgba(15, 16, 22, 0.55)';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1.08)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'rgba(15, 16, 22, 0.35)';
                        e.currentTarget.style.transform = 'translateY(-50%) scale(1)';
                    }}
                >
                    <i className="fas fa-chevron-right" style={{ fontSize: '18px' }} />
                </button>

                {/* Pagination Indicators */}
                <div
                    style={{
                        position: 'absolute',
                        bottom: '24px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        zIndex: 15
                    }}
                >
                    {slides.map((_, idx) => {
                        let normalizedIndex = activeIndex - 1;
                        if (activeIndex === 0) normalizedIndex = slides.length - 1;
                        if (activeIndex === extendedSlides.length - 1) normalizedIndex = 0;
                        const isActive = normalizedIndex === idx;
                        return (
                            <button
                                key={idx}
                                onClick={() => goToSlide(idx)}
                                aria-label={`Go to slide ${idx + 1}`}
                                style={{
                                    width: isActive ? '32px' : '10px',
                                    height: '10px',
                                    borderRadius: '5px',
                                    background: isActive
                                        ? 'linear-gradient(90deg, #00d2ff, #0078ff)'
                                        : 'rgba(15, 16, 22, 0.25)',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: 0,
                                    transition: 'all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)',
                                    boxShadow: isActive ? '0 0 10px rgba(0, 210, 255, 0.6)' : 'none'
                                }}
                            />
                        );
                    })}
                </div>
            </div>
        </>
    );
}

export default HomeSlider;
